export default __webpack_public_path__ + "static/media/poster_diet_tracker.259edfa9.pdf";